import { ChangeDetectorRef } from '@angular/core';

export class CampaignSortUtils {
  /**
   * Retrieves a potentially nested field value from an object using dot notation.
   */
  static getFieldValue(obj: any, field: string): any {
    return field.split('.').reduce((o, f) => o && o[f], obj);
  }

  /**
   * PrimeNG custom sort handler shared between campaign-table and segments-table.
   * Updates currentSortField and currentSortOrder on the component, sorts event.data
   * in-place, and triggers change detection.
   */
  static customSort(
    event: any,
    component: { currentSortField: string; currentSortOrder: string },
    cdr: ChangeDetectorRef
  ): void {
    component.currentSortField = event.field || '';
    component.currentSortOrder = event.order === 1 ? 'asc' : event.order === -1 ? 'desc' : '';

    if (!event.data || event.data.length === 0) {
      return;
    }

    event.data.sort((data1: any, data2: any) => {
      const value1 = CampaignSortUtils.getFieldValue(data1, event.field);
      const value2 = CampaignSortUtils.getFieldValue(data2, event.field);

      let result: number;

      if (value1 === null || value1 === undefined) {
        result = (value2 === null || value2 === undefined) ? 0 : -1;
      } else if (value2 === null || value2 === undefined) {
        result = 1;
      } else if (typeof value1 === 'string' && typeof value2 === 'string') {
        result = value1.localeCompare(value2);
      } else {
        result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
      }

      return event.order * result;
    });

    cdr.detectChanges();
  }

  /**
   * Sort icon path for table column. Shared by campaign-table and segments-table.
   */
  static getSortIcon(
    field: string,
    currentSortField: string,
    currentSortOrder: string
  ): string {
    if (currentSortField !== field || !currentSortOrder) {
      return 'assets/images/package/tabler_arrows-sort.svg';
    }
    return currentSortOrder === 'asc'
      ? 'assets/images/customer/tabler_sort-ascending-letters.svg'
      : 'assets/images/customer/sort-descending-letters.svg';
  }
}
